import { useEffect, useRef, useState } from 'react'
import { wearLabelText } from '../../lib/homeNav'
import { subscribeToWearLogChanges } from '../../lib/wearLogEvents'

export default function WearSaveConfirmation() {
  const [savedWear, setSavedWear] = useState(null)
  const dismissTimer = useRef(null)

  useEffect(() => subscribeToWearLogChanges(change => {
    if (change.type !== 'created' || !change.row) return
    window.clearTimeout(dismissTimer.current)
    setSavedWear(change.row)
    dismissTimer.current = window.setTimeout(() => setSavedWear(null), 5000)
  }), [])

  useEffect(() => () => window.clearTimeout(dismissTimer.current), [])

  if (!savedWear) return null

  return (
    <div
      className="fixed left-4 right-4 z-[60] mx-auto max-w-md animate-fade-in"
      style={{ top: 'calc(env(safe-area-inset-top, 0px) + 4.25rem)' }}
      role="status"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div className="flex items-center gap-3 rounded-2xl border border-sage/60 bg-charcoal-700 px-4 py-3 shadow-2xl">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-sage text-xl font-bold text-charcoal-900">
          ✓
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-bold text-cream">Wear saved to your log</p>
          <p className="mt-0.5 truncate text-xs text-sage">
            {savedWear.fragrance_name || 'Fragrance'} · {wearLabelText(savedWear)}
          </p>
        </div>
        <button
          type="button"
          onClick={() => setSavedWear(null)}
          aria-label="Dismiss saved confirmation"
          className="flex h-8 w-8 shrink-0 items-center justify-center text-xl text-cream/50"
        >
          ×
        </button>
      </div>
    </div>
  )
}
